module.exports = __webpack_public_path__ + "img/old_mc_donald.a81fb9bc.webp";